export default __webpack_public_path__ + "static/media/Snd_LowerQBackdown.b80af44e.mp3";